module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Picker-5a3efa2c4450b4f3f5a0d5ac021b2da0.svg";